import { ref, query as dbQuery, orderByChild, equalTo, limitToLast, onChildAdded, onChildChanged, onChildRemoved, get, child, endAt, startAt, startAfter } from "firebase/database";
import { and, collection, doc, query as fbQuery, getDoc, getDocs, limit, onSnapshot, or, orderBy, where } from "firebase/firestore";
import { db, rtDb } from "@/utils/firebase.utils";

export function getMcsFromDb(e) {
    let mcRef = fbQuery(collection(db, `mcs`))

    if (e.status) {
        mcRef = fbQuery(collection(db, `mcs`), where('status', '==', e.status));
    }
    const unsubscribe = onSnapshot(mcRef, docs => {
        docs.forEach(doc => {
            const data = doc.data();
            e.callback(data);
        });
    })
    e.handleListener(unsubscribe);
}

export async function getIndividualMc(e) {
    let mcRef = fbQuery(collection(db, `mcs`), or(
        where('mc_key', '==', e.mc_key),
        where('mc_keys_alt', 'array-contains', e.mc_key)
    ));
    const mcDocs = await getDocs(mcRef);
    return mcDocs.docs.length > 0 ? mcDocs.docs[0].data() : null;
    
}

export function getUsersFromDb(e) {
    let userRef;

    if (e.status) {
        userRef = fbQuery(collection(db, 'users'), where('status', '==', e.status));
    } else {
        userRef = fbQuery(collection(db, 'users'))
    }

    const unsubscribe = onSnapshot(userRef, docs => {
        docs.forEach(doc => {
            const data = doc.data();
            e.callback(data, doc.id);
        });
    })
    e.handleListener(unsubscribe);
}

export function getImportedUsersFromDb(e) {
    let listRef = doc(db, 'utils/importedUsers');
    const unsubscribe = onSnapshot(listRef, doc => {
        e.callback(doc.data());
    })
    e.handleListener(unsubscribe);
}

export function getImportedMcsFromDb(e) {
    let listRef = doc(db, 'utils/importedMcs');
    const unsubscribe = onSnapshot(listRef, doc => {
        e.callback(doc.data());
    })
    e.handleListener(unsubscribe);
}

export function getUserMcsFromDb(e) {
    let regListRef;

    if (e.cst_key && e.mc_key) {
        regListRef = fbQuery(collection(db, 'regs'), and(where('list', 'array-contains', e.cst_key), where('mc_key', '==', e.mc_key)))
    } else if (e.cst_key && e.status) {
        regListRef = fbQuery(collection(db, 'regs'), and(where('list', 'array-contains', e.cst_key), where('status', '==', e.status)))
    } else if (e.cst_key) {
        regListRef = fbQuery(collection(db, 'regs'), where('list', 'array-contains', e.cst_key))
    }

    const unsubscribe = onSnapshot(regListRef, docs => {
        let mcObj = {};
        let count = 0;
        if (docs.size === 0) {
            e.callback({});
            return;
        }
        docs.forEach(async regDoc => {
            const data = regDoc.data();
            // get MC data
            const mcRef = doc(db, `mcs/${data.mc_key}`);
            const mcDoc = await getDoc(mcRef);
            let newMcDoc = mcDoc.data();
            newMcDoc.roles = data.roles[e.cst_key];
            
            // // get user progress
            // const progressRef = doc(db, `progress/${data.mc_key}_${e.cst_key}`)
            // const progressDoc = await getDoc(progressRef);
            // let progress = null;
            // if (progressDoc.exists) {
            //     progress = progressDoc.data()
            // }
            // if (data.imported.includes(e.cst_key) && !progress) {
            //     newMcDoc.imported = true;
            // }
            mcObj[data.mc_key] = {'mcData': newMcDoc};
            count++;
            if (count === docs.size) {
                e.callback(mcObj);
            }
        });
    })
    e.handleListener(unsubscribe);
}

export function getMcDataFromDb(e) {
    let mcRef;

    if (e.mc_key) {
        mcRef = doc(db, `mcs/${e.mc_key}`);
    }
    const unsubscribe = onSnapshot(mcRef, doc => {
        e.callback(doc.data());
    })
    e.handleListener(unsubscribe);
}

export function getProgressFromDb(e) {
    let progressRef;

    if (e.cst_key && e.mc_key) {
        progressRef = doc(db, `progress/${e.mc_key}_${e.cst_key}`);
    } else if (e.progressId) {
        progressRef = doc(db, `progress/${e.progressId}`);
    }    

    const unsubscribe = onSnapshot(progressRef, doc => {
        e.callback(doc.data());
    })
    e.handleListener(unsubscribe);
}

export function getMcRegsFromDb(e) {
    let regsRef;

    if (e.mc_key) {
        regsRef = doc(db, `regs/${e.mc_key}`);
    }

    const unsubscribe = onSnapshot(regsRef, async document => {
        const regsData = document.data();
        // let fullObj = {
        //     'regs': regsData,
        //     // 'progress': {},
        //     'users': {},
        // }
        // for (let r of regsData.list) {
        //     const userDocRef = doc(db, `users/${r}`);
        //     const userDoc = await getDoc(userDocRef);
        //     if (userDoc.exists() && regsData.roles[r].includes('part')) {
        //         fullObj.users[r] = userDoc.data();
        //     }
        //     // const progressDocRef = doc(db, `progress/${e.mc_key}_${r}`);
        //     // const progDoc = await getDoc(progressDocRef);
        //     // if (progDoc.data()) {
        //     //     fullObj.progress[`${e.mc_key}_${r}`] = progDoc.data();
        //     // }    
        // }
        e.callback(regsData);
    })
    e.handleListener(unsubscribe);
}


export function getEarnedBadgesFromDb(e) {
    let badgesRef;

    if (e.cst_key) {
        badgesRef = fbQuery(collection(db, 'earnedBadges'), and(where('cst_key', '==', e.cst_key), where('status', '==', 'active')));
    }

    const unsubscribe = onSnapshot(badgesRef, docs => {
        docs.forEach(async docSnap => {
            const data = docSnap.data();
            e.callback(data);
        })
    })
    e.handleListener(unsubscribe);
}

export async function getUniqueDocFromDb(e) {
    let ref = doc(db, e.path);
    
    if (e.once) {
        const doc = await getDoc(ref);
        e.callback(doc.data());
        return;
    }
    
    const unsubscribe = onSnapshot(ref, doc => {
        // console.log(doc.data());
        e.callback(doc.data());
    })
    e.handleListener(unsubscribe);
}

export async function getCollectionFromDb(e) {
    let queryRef = fbQuery(collection(db, e.path))

    if (e.once) {
        const docs = await getDocs(collection(db, e.path));
        let docObj = {}
        docs.forEach((doc) => {
            docObj[doc.id] = doc.data();
        });
        e.callback(docObj);
        return;
    }

    if (e.status) {
        queryRef = fbQuery(collection(db, e.path), where('status', '==', e.status));
    }
    const unsubscribe = onSnapshot(queryRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data(), doc.id);
        })
    })
    e.handleListener(unsubscribe);
}

export async function getCollectionQueryFromDb(e) {
    let queryRef;

    if (e.param1) {
        queryRef = fbQuery(
            collection(db, e.path), 
            where(e.param1.key, e.param1.condition, e.param1.value)
        );
    } if (e.param1 && e.param2) {
        queryRef = fbQuery(
            collection(db, e.path), 
            and(
                where(e.param1.key, e.param1.condition, e.param1.value),
                where(e.param2.key, e.param2.condition, e.param2.value)
            )
        )
    }

    if (e.once) {
        const docs = await getDocs(queryRef);
        let docObj = {}
        docs.forEach((doc) => {
            docObj[doc.id] = doc.data();
        });
        e.callback(docObj);
        return;
    }   

    const unsubscribe = onSnapshot(queryRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data(), doc.id);
        })
    })
    e.handleListener(unsubscribe);
}

export async function getCompiledDataFromDb(e) {
    let dataRef;

    let filterArr = [];
    for (let f of Object.keys(e)) {
        if (f !== 'callback' && f !== 'handleListener' && f !== 'once') {
            if (f === 'startDate') {
                filterArr.push(where('ts', '>=', e[f]));
            } else if (f === 'endDate') {
                filterArr.push(where('ts', '<=', e[f]));
            } else {
                filterArr.push(where(f, '==', e[f]));
            }
        }
    }
    console.log(filterArr);
    if (filterArr.length > 1) {
        dataRef = fbQuery(collection(db, "compiledData"), and(...filterArr))
    } else if (filterArr.length === 1) {
        dataRef = fbQuery(collection(db, "compiledData"), filterArr[0])
    } else {
        dataRef = fbQuery(collection(db, "compiledData"))
    }

    if (e.once) {
        const docs = await getDocs(dataRef);
        let docObj = {}
        docs.forEach((doc) => {
            docObj[doc.id] = doc.data();
        });
        e.callback(docObj);
        return;
    }   

    const unsubscribe = onSnapshot(dataRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data(), doc.id);
        })
    })
    e.handleListener(unsubscribe);
}

export async function getRealTimeQueryFromDb(e) {
    let dataRef;
    
    if (e.child && e.value) {
        dataRef = dbQuery(ref(rtDb, e.path), orderByChild(e.child), equalTo(e.value))
    }

    get(dataRef).then(snap => {
        let obj = {}
        if (snap.exists()) {
            snap.forEach(doc => {
                const data = doc.val();
                console.log(data);
                obj[data.id] = data;
            });
        }
        e.callback(obj);
    })
}

export async function getActivityLogsFromDb(e) {
    let activityLogsRef;
    
    if (e.cst_key && e.lastId) {
        activityLogsRef = fbQuery(collection(db, 'activity'), and(where('user', '==', e.cst_key), where('ts', '<', e.lastId), orderBy('ts', 'desc')), limit(40));
    } else if (e.cst_key && e.type) {
        activityLogsRef = fbQuery(collection(db, 'activity'), and(where('user', '==', e.cst_key), where('type', '==', e.type), orderBy('ts', 'desc')));
    } else if (e.cst_key) {
        activityLogsRef = fbQuery(collection(db, 'activity'), where('user', '==', e.cst_key), orderBy('ts', 'desc'), limit(40));
    } else if (e.type) {
        activityLogsRef = fbQuery(collection(db, 'activity'), where('type', '==', e.type), orderBy('ts', 'desc'), limit(40));
    } else if (e.startDate && e.endDate) {
        activityLogsRef = fbQuery(collection(db, 'activity'), and(where('ts', '>=', e.startDate), where('ts', '<=', e.endDate), orderBy('ts', 'desc')));
    } else if (e.startDate) {
        activityLogsRef = fbQuery(collection(db, 'activity'), where('ts', '>=', e.startDate), orderBy('ts', 'desc'));
    } else if (e.lastId) {
        activityLogsRef = fbQuery(collection(db, 'activity'), where('ts', '>', e.lastId), orderBy('ts', 'desc'), limit(40));
    } else {
        console.log('getting all')
        activityLogsRef = fbQuery(collection(db, 'activity'), orderBy('ts', 'desc'), limit(40));
    }
    const unsubscribe = onSnapshot(activityLogsRef, docs => {
        docs.forEach(doc => {
            e.callback(doc.data(), doc.id);
        })
    })
    e.handleListener(unsubscribe);
}

export async function getBugReports(e) {
    let bugsRef;
    
    if (e.onlyActive) {
        bugsRef = fbQuery(collection(db, `bugReports`), where('status', '==', 'active'))
    } else {
        bugsRef = fbQuery(collection(db, `bugReports`));
    }
    const unsubscribe = onSnapshot(bugsRef, docs => {
        docs.forEach(doc => {
            const data = doc.data();
            e.callback(data);
        });
    })
    e.receiveListener(unsubscribe);
}